// admin/src/lib/vocab.ts
//
// Vocabularies mirrored from the schema this admin writes against:
//   - exercises.sport / muscle_group / kind / load_mode / equipment
//     (supabase/migrations/0004_strength_core.sql, 0013_builder.sql) --
//     also src/features/exercises/schema.ts and src/features/builder/schema.ts
//     on the app side, which this file is kept in sync with by hand.
//   - equipment.category / equipment.class (supabase/migrations/0025_media_library.sql)
// Keeping these as plain arrays (not an import across the Expo/RN
// boundary) lets the admin site validate client-side before it ever hits
// a CHECK constraint, and lets the picker/filter UIs render friendly
// labels.

export const SPORTS = ['strength', 'calisthenics', 'swim', 'stretch'] as const;
export type Sport = (typeof SPORTS)[number];

export const MUSCLE_GROUPS = [
  'chest', 'back', 'shoulders', 'arms', 'legs', 'core', 'full_body', 'glutes', 'calves', 'forearms', 'neck',
] as const;
export type MuscleGroup = (typeof MUSCLE_GROUPS)[number];

export const EXERCISE_KINDS = ['weight_reps', 'bodyweight_reps', 'hold', 'distance_time'] as const;
export type ExerciseKind = (typeof EXERCISE_KINDS)[number];

export const LOAD_MODES = ['external', 'bodyweight'] as const;
export type LoadMode = (typeof LOAD_MODES)[number];

/** exercises.equipment: the coarse class a library row carries (0013). */
export const EQUIPMENT_CLASSES = [
  'barbell', 'dumbbell', 'cable', 'machine', 'bodyweight', 'kettlebell', 'band', 'other',
  'pullup_bar', 'dip_bars', 'rings', 'bench', 'trx', 'pool', 'none',
] as const;
export type EquipmentClass = (typeof EQUIPMENT_CLASSES)[number];

/** equipment.category (0025). */
export const EQUIPMENT_CATEGORIES = [
  'free_weights', 'machines', 'cables', 'racks_benches', 'bodyweight', 'cardio', 'accessories', 'pool', 'other',
] as const;
export type EquipmentCategory = (typeof EQUIPMENT_CATEGORIES)[number];

export const MEDIA_KINDS = ['demo_photo', 'video', 'image'] as const;
export type MediaKind = (typeof MEDIA_KINDS)[number];

export const LABELS: Record<string, string> = {
  // sport
  strength: 'Strength', calisthenics: 'Calisthenics', swim: 'Swim', stretch: 'Stretch',
  // muscle group
  chest: 'Chest', back: 'Back', shoulders: 'Shoulders', arms: 'Arms', legs: 'Legs', core: 'Core',
  full_body: 'Full body', glutes: 'Glutes', calves: 'Calves', forearms: 'Forearms', neck: 'Neck',
  // kind
  weight_reps: 'Weight x reps', bodyweight_reps: 'Bodyweight reps', hold: 'Hold', distance_time: 'Distance + time',
  // load mode
  external: 'External load', bodyweight: 'Bodyweight',
  // equipment class
  barbell: 'Barbell', dumbbell: 'Dumbbell', cable: 'Cable', machine: 'Machine', kettlebell: 'Kettlebell',
  band: 'Band', other: 'Other', pullup_bar: 'Pull-up bar', dip_bars: 'Dip bars', rings: 'Rings',
  bench: 'Bench', trx: 'TRX', pool: 'Pool', none: 'None',
  // equipment category
  free_weights: 'Free weights', machines: 'Machines', cables: 'Cables', racks_benches: 'Racks & benches',
  cardio: 'Cardio', accessories: 'Accessories',
  // review cards for equipment photos
  equipment: 'Equipment',
};

export function label(key: string): string {
  return LABELS[key] ?? key;
}
